import styled from 'styled-components';

import { colors } from '../../../../theme';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem 0;
`;

export const IntroText = styled.p`
  margin-bottom: 1rem;
  color: ${colors.gray};
  font-weight: 400;
  font-size: 16px;
  line-height: 160%;
`;

export const SubmitError = styled.p`
  color: ${colors.error};
  margin-top: 1rem;
  font-weight: 500;
`;

export const SuccessMessage = styled.p`
  color: ${colors.darkGray};
  font-weight: 600;
  font-size: 18px;
  line-height: 160%;
`;
